import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import "./assets/css/general.css";
import "./assets/css/index.css";
import "./assets/css/pages-icons.css";
import "./assets/css/pages-sidebar.css";
import { FirebaseMessagingProvider } from './contexts/FirebaseMessagingContext';
import { IncomingCallProvider } from './contexts/IncomingCallContext';
import { PatientProvider } from './contexts';
import PageLayout from './components/layouts/PageLayout';
import { Toaster } from 'react-hot-toast';
import { BedProvider } from './contexts/bedContext';
import Connect from './components/home/connect';
import Home from './components/home';
import SignUp from './components/pages/SignUp';

navigator.serviceWorker.register('/firebase-messaging-sw.js')
  .then((registration) => {
    console.log('Service worker registered:', registration);
  })
  .catch((error) => {
    console.error('Service worker registration failed:', error);
  });

const App = () => {
  const [warningDisplayed, setWarningDisplayed] = useState(false);
  const [inactivityWarning, setInactivityWarning] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);
  const [minutesLeft, setMinutesLeft] = useState(null);
  const [inactivityMinutesLeft, setInactivityMinutesLeft] = useState(5); // 5 minutes countdown


  return (
    <PatientProvider>
      <BedProvider>
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="*" element={<PageLayout />} />
            <Route element={<h1>Error 404. Page not found.</h1>} />
          </Routes>
          {warningDisplayed && (
            <div style={toastStyle}>
              <span role="img" aria-label="warning">⚠️</span>
              {` Session will time out in ${minutesLeft} minutes`}
            </div>
          )}
          {sessionExpired && (
            <div style={toastStyle}>
              <span role="img" aria-label="error">❌</span>
              {` Session has timed out. Please login again.`}
            </div>
          )}
          {inactivityWarning && (
            <div style={toastStyle}>
              <span role="img" aria-label="warning">⚠️</span>
              {`You will be logged out in ${inactivityMinutesLeft} minutes due to inactivity.`}
            </div>
          )}
        </div>
      </BedProvider>
    </PatientProvider>
  );
};

const toastStyle = {
  position: 'fixed',
  top: '20px',
  left: '22%',
  transform: 'translateX(-50%)',
  backgroundColor: '#393939',
  color: '#fff',
  padding: '15px',
  borderRadius: '5px',
  boxShadow: '1px 4px 11px 0px #35353628',
  zIndex: 1000,
  display: 'flex',
  alignItems: 'center',
  gap: '10px'
};

const RootApp = () => (
  <IncomingCallProvider>
    <FirebaseMessagingProvider>
      <BrowserRouter>
        <App />
        <Toaster />
      </BrowserRouter>
    </FirebaseMessagingProvider>
  </IncomingCallProvider>
);

export default RootApp;
